<template>
    <div class="maintainer-list relative">
        <div class="buttons" :style="{position: button_position}">
<!--            <el-button @click="reset">重置</el-button>-->
<!--            <el-button @click="search">筛选</el-button>-->
            <el-button type="primary" @click="exportExcel">导出数据</el-button>
        </div>

        <el-row class="inputs mg-20" :gutter="20">
            <el-col :md="7" :lg="4" :xl="5" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">用户搜索：</span>
                <el-input v-model="search_data" placeholder="姓名或手机号码模糊搜索"></el-input>
            </el-col>
            <el-col :md="7" :lg="5" :xl="5" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">加入时间：</span>
                <el-date-picker
                    v-model="search_expired_date"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    @change="dateChange"
                ></el-date-picker>
            </el-col>
            <el-col :md="7" :lg="5" :xl="5" :sm="12" :xs="24">
                <el-button @click="reset">重置</el-button>
                <el-button @click="search">筛选</el-button>
            </el-col>
        </el-row>

        <el-table :data="tableData" border style="width: 100%">
<!--            <el-table-column prop="id" label="ID" align="center" label-class-name="label"></el-table-column>-->
            <el-table-column width="80" prop="no" label="序号" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="200" prop="user_name" label="姓名" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="mobile" label="手机号码" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="bank_name" label="开户行" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="bank_card" label="银行卡号" align="center" label-class-name="label"></el-table-column>
            <el-table-column label="银行卡照片" align="center" label-class-name="label" v-slot="scope">
                <div v-if="scope.row.bankcard_img">
                    <div style="display: inline;margin-right: 2px"
                         @click="previewImage(scope.row.bankcard_img, 0, scope.row.user_name)">
                        <i class="el-icon-picture-outline"></i></div></div>
            </el-table-column>
            <el-table-column prop="create_date" label="加入时间" align="center" label-class-name="label"></el-table-column>
        </el-table>
        <el-pagination
                class="mg-20 ta-r"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="[10, 25, 50, 100]"
                :total="total"
                :page-size="perpage"
                :current-page="page"
                @current-change="changePage"
                @size-change="changeSite" :sm="6" :xs="6"
        ></el-pagination>

        <el-dialog :title="preview_title" :visible.sync="dialogImgFormVisible">
            <el-carousel ref="image_box" id="image_detail" indicator-position="none" height="500px"  arrow="never" :autoplay="false" :initial-index="0" :loop="false">
                <el-carousel-item v-for="(url, n) in imageUrl" :key="n">
                    <div class="image_box">
                        <el-image :src="url"></el-image>
                    </div>
                </el-carousel-item>
            </el-carousel>
        </el-dialog>
    </div>
</template>
<script>
    import {check} from "@/utils/checkData";
    import env from "@/api/env";
    import {export2Excel} from "@/utils/excel";
    import {isMobile} from "@/api/order";

    export default {
        data() {
            return {
                page: 1,
                perpage: 10,
                total: 0,
                tableData: [],
                //搜索栏
                account: '',
                user_name: '',
                user_role: '',
                start_date: '',
                end_date: '',
                search_expired_date: '',
                search_data: '',
                is_submit: false,
                dialogImgFormVisible: false,
                preview_title: '',
                imageUrl: [],
                imgPREFIX: env.IMG_COMMON_URL_PREFIX,
                button_position: 'absolute',
            };
        },
        created() {
            if (isMobile()) {
                this.button_position = 'static'
            }
        },
        mounted() {
            //获取日志列表
            this.getList();
            localStorage.setItem('prev_page', 'log_list')
        },
        methods: {
            //获取日志列表
            getList() {
                let params = {
                    servername: 'Ruyi_StatementsServices',
                    method: 'getBankCardList',
                    pageinfo: {
                        page: this.page,
                        perpage: this.perpage,
                    },
                    params: {
                        user_role: this.user_role,
                        search_data: this.search_data,
                        start_date: this.start_date,
                        end_date: this.end_date,
                    },
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        this.is_submit = false;
                        return;
                    }
                    let len = res.data.data.list.length
                    for (var i = 0; i < len; i++) {
                        // 序号
                        res.data.data.list[i].no = (this.page - 1) * this.perpage + i + 1
                    }
                    this.tableData = res.data.data.list;
                    this.total = res.data.data.page.count;
                    this.is_submit = false;
                }).catch(() => {
                    this.is_submit = false;
                }).finally(() => {
                    this.is_submit = false;
                });
            },
            dateChange(e){
                if (!e) {
                    this.search_expired_date = null
                    this.start_date = ''
                    this.end_date = ''
                }
            },
            //搜索
            search() {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复操作',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                this.page = 1;
                if (this.search_expired_date) {
                    this.start_date = this.search_expired_date[0];
                    this.end_date = this.search_expired_date[1];
                }
                this.getList();
            },

            // 改变每页条数
            changeSite(index) {
                this.perpage = index;
                this.getList();
            },

            //更换页码
            changePage(index) {
                this.page = index;
                this.getList();
            },

            reset() {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复操作',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                this.user_role = '';
                this.page = 1;
                this.search_data = '';
                this.start_date = "";
                this.end_date = "";
                this.search_expired_date = "";
                this.getList();
            },
            // 预览
            async previewImage(img, index, title){
                if (this.$refs.image_box) {
                    this.$refs.image_box.setActiveItem(index)
                }
                this.imageUrl = [];

                this.imageUrl.push(this.imgPREFIX + img);

                this.preview_title = title + '的银行卡照片'
                this.active_index = index
                this.dialogImgFormVisible = true;

            },
            // 导出数据
            exportExcel() {
                let params = {
                    servername: 'Ruyi_StatementsServices',
                    method: 'getBankCardList',
                    params: {
                        user_role: this.user_role,
                        search_data: this.search_data,
                        start_date: this.start_date,
                        end_date: this.end_date,
                    },
                };

                let colums_list = [
                    {title: "姓名", key: "user_name"},
                    {title: "手机号码", key: "mobile"},
                    {title: "用户类型", key: "user_role_txt"},
                    {title: "银行卡号", key: "bank_card"},
                ];


                let export_data = [];
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }

                    let res_data = res.data;

                    if (parseInt(res_data.code) != 0) {
                        this.$message.error(res_data.msg);
                        return false;
                    }

                    let len = res.data.data.list.length
                    for (let i = 0; i < len; i++) {
                        // 序号
                        res.data.data.list[i].no = (this.page - 1) * this.perpage + i + 1
                        let item = {
                            user_name: res.data.data.list[i].user_name,
                            mobile: res.data.data.list[i].mobile,
                            user_role_txt: res.data.data.list[i].user_role,
                            bank_card: res.data.data.list[i].bank_card,
                        };

                        export_data.push(item);
                    }

                    let file_name = `银行卡号导出表`

                    export2Excel(colums_list, export_data, file_name);
                });
            },
        }
    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";

    .el-icon-picture-outline,.ad-coentent{color: #6B99F0;cursor: pointer;}
</style>

